module.exports = __webpack_public_path__ + "img/pic5.e1718258.png";